import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { CssVarsProvider, CssBaseline } from '@mui/material';
import { Provider } from 'mobx-react';
import theme from '../themes';
import models from '../store';
import AppRoutes from './routes';

function App() {
    return (
        <CssVarsProvider theme={theme} defaultMode="light">
            <CssBaseline />
            <Provider store={models}>
                <BrowserRouter>
                    <AppRoutes />
                </BrowserRouter>
            </Provider>
        </CssVarsProvider>
    );
}

export default App;
